import React, { useEffect } from "react";
import { BookingScheduleInterface } from "../../features/Booking-Form/typings/booking.types";
import { Chip, Grid2, IconButton, Tooltip, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { EventBusy } from "@mui/icons-material";
import { MbscCalendarEvent } from "@mobiscroll/react";
import { DateTime } from "luxon";
import { useRemoteDeleteBookingVisitors } from "../../hooks/Remote/Booking/useRemoteDeleteBookingVisitors";

type P = {
  userId: string;
  schedule: BookingScheduleInterface;
  calendarData: MbscCalendarEvent[];
  onCalendarDataChange?: (events: MbscCalendarEvent[]) => void;
  onClose: () => void;
  refetchAllSchedule?: () => void;
  /** When false (e.g. resource schedule view), visitor cannot reject the invitation. */
  canRejectInvitation?: boolean;
};

export const ScheduleEventBookingHeaderVisitorsContents: React.FC<P> = ({
  userId,
  schedule,
  calendarData,
  onCalendarDataChange,
  onClose,
  refetchAllSchedule,
  canRejectInvitation = true
}) => {
  const { t } = useTranslation();
  const visitorIds = (schedule.guests ?? []).find(guest => guest.userId === userId)?.id;

  const { mutate: deleteBookingVisitor, status: deleteBookingVisitorStatus } =
    useRemoteDeleteBookingVisitors(visitorIds ?? 0);

  const handleDeleteBookingVisitor = () => {
    if (!visitorIds) return;
    deleteBookingVisitor(undefined);
  };

  const handleDeleteBookingVisitorSuccess = () => {
    const index = calendarData.findIndex(c => c.id === schedule.id);
    if (index >= 0) {
      const newCalendarData = calendarData.slice();
      newCalendarData.splice(index, 1);
      onCalendarDataChange?.(newCalendarData);
      onClose();
    }
    refetchAllSchedule?.();
  };

  useEffect(() => {
    if (deleteBookingVisitorStatus === "success") handleDeleteBookingVisitorSuccess();
  }, [deleteBookingVisitorStatus]);

  return (
    <>
      <Grid2 sx={{ alignContent: "center", fontSize: "0.8rem" }}>
        <Chip
          label={t("You are a participant")}
          size="small"
          sx={{ fontSize: "0.85rem", height: "32px", borderRadius: "16px" }}
        />
      </Grid2>
      {canRejectInvitation &&
        DateTime.fromISO(schedule.startDate).valueOf() > DateTime.now().valueOf() && (
          <Grid2>
            <Tooltip
              title={<Typography>{t("Reject invitation")}</Typography>}
              aria-label={"Reject invitation"}
            >
              <IconButton
                sx={{ color: "inherit", p: 1 }}
                onClick={handleDeleteBookingVisitor}
                data-testid="schedule-visitor-busy-btn"
                size="large"
              >
                <EventBusy />
              </IconButton>
            </Tooltip>
          </Grid2>
        )}
    </>
  );
};
